import React from 'react';
import exam_result_icon_ru from '../images/exam_result_icon_ru.png';
import exam_result_icon_kz from '../images/exam_result_icon_kz.png';
import { useTranslation } from 'react-i18next';

const ExamResultSection = () => {
  const [t, i18n] = useTranslation();

  return (
    <div className='flex w-screen  flex-col items-center gap-20 bg-white py-16 xl:flex-row xl:justify-center '>
      <img
        className='hidden md:flex'
        width={468}
        height={520}
        src={i18n.language === 'ru' ? exam_result_icon_ru : exam_result_icon_kz}
        alt='exam result'
      />

      <div className='flex flex-col gap-8 text-center sm:w-[40rem] sm:text-left  '>
        <p className='font-sfproBold text-5xl'>
          <span>{t('welcome.examination_results_1_1')} </span>{' '}
          <span className='text-brown'>
            {t('welcome.examination_results_1_2')}
          </span>{' '}
          <span> {t('welcome.examination_results_1_3')}</span>
        </p>
        <div className='flex flex-row gap-5 px-5 sm:px-0'>

          <ul className='text-2xl'>
            <li>
              {t('welcome.examination_results_3_1')}
              <span className='text-brown'>
                {t('welcome.examination_results_3_2')}
              </span>
              {t('welcome.examination_results_3_3')}
            </li>
          </ul>
        </div>
        <div className='flex flex-row gap-5 px-5 sm:px-0'>
          <ul className='text-2xl'>
            <li>
              <span>{t('welcome.examination_results_2_1_1')}</span>{' '}
              <a
                className='text-primary hover:underline'
                href='https://bilemtihan.kz'
              >
                bilemtihan.kz
              </a>{' '}
              <span>{t('welcome.examination_results_2_1_2')}</span>
            </li>
          </ul>
        </div>

        <img
          className='flex w-[89.6%] self-center md:hidden'
          src={
            i18n.language === 'ru' ? exam_result_icon_ru : exam_result_icon_kz
          }
          alt='exam result'
        />
      </div>
    </div>
  );
};

export default ExamResultSection;
